<div class="user-dashboard">
  <!-- Loading Progress Bar -->
  @if (isLoading) {
  <div class="loading-bar-container">
    <div class="loading-bar">
      <div class="loading-bar-progress"></div>
    </div>
    <div class="loading-message">
      <svg class="loading-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <path
          d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83">
        </path>
      </svg>
      <span>กำลังโหลดข้อมูลผู้ใช้งาน...</span>
    </div>
  </div>
  }

  <!-- Skeleton Loading Content -->
  @if (isLoading) {
  <div class="skeleton-dashboard">
    <div class="skeleton-header">
      <div class="skeleton-logo"></div>
      <div class="skeleton-user">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-text-group">
          <div class="skeleton-text skeleton-text-short"></div>
          <div class="skeleton-text skeleton-text-tiny"></div>
        </div>
      </div>
    </div>

    <div class="skeleton-content">
      <div class="skeleton-welcome">
        <div class="skeleton-text skeleton-text-large"></div>
        <div class="skeleton-text skeleton-text-medium"></div>
      </div>

      <div class="skeleton-card skeleton-progress-card">
        <div class="skeleton-text skeleton-text-medium"></div>
        <div class="skeleton-progress-bar"></div>
        <div class="skeleton-stats">
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
        </div>
      </div>

      <div class="skeleton-grid">
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
      </div>
    </div>
  </div>
  }

  <!-- Error State -->
  @if (!isLoading && error) {
  <div class="error-container">
    <div class="error-card">
      <svg class="error-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
      <h2 class="error-title">เกิดข้อผิดพลาด</h2>
      <p class="error-message">{{ error }}</p>
      <button class="btn-retry" (click)="refreshData()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="23 4 23 10 17 10"></polyline>
          <polyline points="1 20 1 14 7 14"></polyline>
          <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        </svg>
        ลองใหม่อีกครั้ง
      </button>
    </div>
  </div>
  }

  <!-- Main Dashboard Content -->
  @if (!isLoading && !error && userDetails) {
  <div class="dashboard-content">
    <!-- Header -->
    <header class="dashboard-header">
      <div class="header-container">
        <div class="header-left">
          <div class="logo-section">
            <img src="/vat-logo.png" alt="VAT Logo" class="logo-icon">
            <div class="logo-text">
              <h1>VAT E-Service</h1>              
              <p>ระบบให้บริการออนไลน์ สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย</p>
              <span class="version-number">Version 1.0.0</span>
            </div>
          </div>
        </div>

        <div class="header-right">
          <div class="user-info">
            <div class="user-avatar">
              @if (userProfileImage) {
                <img [src]="userProfileImage" 
                     [alt]="userName"
                     class="profile-image">
              } @else {
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              }
            </div>
            <div class="user-details">
              <div class="user-name-row">
                <span class="user-name">{{ userName }}</span>
                <span class="user-status-badge" [ngClass]="userStatusClass">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                  {{ userStatusName || (userDetails.isActive ? 'ใช้งาน' : 'ไม่ใช้งาน') }}
                </span>
              </div>
              <span class="user-role">{{ userRole }}</span>
            </div>
          </div>

          <button class="btn-logout" (click)="onLogout()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16,17 21,12 16,7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            ออกจากระบบ
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <div class="content-container">
        <!-- Welcome Section -->
        <section class="welcome-section">
          <div class="welcome-content">
            <h2 class="welcome-title">สวัสดี, {{ userName }}</h2>
            <p class="welcome-subtitle">{{ organization }} • {{ userRole }}</p>
          </div>
          <div class="welcome-actions">
            <button class="btn-refresh" (click)="refreshData()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
              รีเฟรชข้อมูล
            </button>
          </div>
        </section>

        <!-- License Alerts -->
        @if (isVatExpired || isValuerExpired || isVatExpiringSoon || isValuerExpiringSoon) {
        <section class="alerts-section">
          @if (isVatExpired) {
          <div class="alert alert-danger">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            <div>
              <strong>บัตรสมาชิก VAT หมดอายุแล้ว!</strong>
              <p>กรุณาติดต่อเจ้าหน้าที่เพื่อต่ออายุบัตรสมาชิก</p>
            </div>
          </div>
          }

          @if (isValuerExpired) {
          <div class="alert alert-danger">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            <div>
              <strong>บัตรสมาชิกผู้ประเมินหมดอายุแล้ว!</strong>
              <p>กรุณาติดต่อเจ้าหน้าที่เพื่อต่ออายุบัตรสมาชิก</p>
            </div>
          </div>
          }

          @if (isVatExpiringSoon && !isVatExpired) {
          <div class="alert alert-warning">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <div>
              <strong>บัตรสมาชิก VAT จะหมดอายุใน {{ vatExpiringDays }} วัน</strong>
              <p>กรุณาเตรียมพร้อมสำหรับการต่ออายุ</p>
            </div>
          </div>
          }

          @if (isValuerExpiringSoon && !isValuerExpired) {
          <div class="alert alert-warning">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <div>
              <strong>บัตรสมาชิกผู้ประเมินจะหมดอายุใน {{ valuerExpiringDays }} วัน</strong>
              <p>กรุณาเตรียมพร้อมสำหรับการต่ออายุ</p>
            </div>
          </div>
          }
        </section>
        }

        <!-- CPD Progress Card -->
        <section class="cpd-progress-section">
          <div class="progress-card">
            <div class="progress-header">
              <div class="progress-info">
                <h3>VAT CPD ที่ยังใช้ได้ในรอบ 3 ปี</h3>
                <p>ชั่วโมงที่สะสมได้ {{ totalCpdHours }} จาก {{ requiredCpdHours }} ชั่วโมง</p>
              </div>
              <div class="progress-percentage">
                <span class="percentage-value">{{ cpdProgress | number:'1.0-0' }}%</span>
              </div>
            </div>

            <div class="progress-bar-container">
              <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="cpdProgress"></div>
              </div>
            </div>

            <div class="progress-stats">
              <div class="stat-item vat-cpd clickable" (click)="viewCourseList('3years')" role="button" tabindex="0"
                title="VAT CPD ที่ยังใช้ได้ในรอบ 3 ปี">
                <div class="stat-icon vat">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 6v6l4 2"></path>
                  </svg>
                </div>
                <div class="stat-details">
                  <span class="stat-label">
                    VAT CPD
                    <i class="bi bi-box-arrow-up-right ms-1" style="font-size: 0.8rem;"></i>
                  </span>
                  @if (!isLoadingCpd) {
                  <span class="stat-value">
                    {{ vatCpdHours }} ชม.
                    <small class="d-block text-muted"
                      style="font-size: 0.75rem; font-weight: 500; margin-top: 4px;">ดูรายละเอียดเพิ่ม</small>
                  </span>
                  }
                  @if (isLoadingCpd) {
                  <span class="stat-value loading">
                    <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                  </span>
                  }
                </div>
              </div>

              <div class="stat-item remaining-cpd">
                <div class="stat-icon remaining">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                </div>
                <div class="stat-details">
                  <span class="stat-label">VAT CPD ที่ยังต้องการ</span>
                  <span class="stat-value">{{ remainingCpdHours }} ชม.</span>
                </div>
              </div>

              <div class="stat-item my-courses clickable" (click)="viewCourseList('all')" role="button" tabindex="0"
                title="คลิกเพื่อดูหลักสูตรทั้งหมดของฉัน">
                <div class="stat-icon my-courses-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                </div>
                <div class="stat-details">
                  <span class="stat-label">
                    การอบรมสัมมนา
                    <i class="bi bi-box-arrow-up-right ms-1" style="font-size: 0.8rem;"></i>
                  </span>
                  @if (!isLoadingCpd) {
                  <span class="stat-value">
                    {{ totalCourseCount }} คอร์ส
                    <small class="d-block text-muted"
                      style="font-size: 0.75rem; font-weight: 500; margin-top: 4px;">ดูรายละเอียดเพิ่ม</small>
                  </span>
                  }
                  @if (isLoadingCpd) {
                  <span class="stat-value loading">
                    <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                  </span>
                  }
                </div>
              </div>

              <div class="stat-item check-exam clickable" (click)="viewExamList()" role="button" tabindex="0"
                title="เช็คผลการสอบและลงทะเบียน">
                <div class="stat-icon check-exam-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 11l3 3L22 4"></path>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                </div>
                <div class="stat-details">
                  <span class="stat-label">
                    การสอบวัดความรู้ทางวิชาชีพ
                    <i class="bi bi-box-arrow-up-right ms-1" style="font-size: 0.8rem;"></i>
                  </span>
                  @if (!isLoadingUserExams) {
                  <span class="stat-value">
                    {{ userExamsCount }} รายการ
                    <small class="d-block text-muted"
                      style="font-size: 0.75rem; font-weight: 500; margin-top: 4px;">ดูรายละเอียดเพิ่ม</small>
                  </span>
                  }
                  @if (isLoadingUserExams) {
                  <span class="stat-value loading">
                    <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                  </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- User Information Grid -->
        <section class="info-grid">
          <!-- Personal Information Card -->
          <div class="info-card">
            <div class="card-header">
              <svg class="card-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <h3>ข้อมูลส่วนตัว</h3>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">ชื่อ-นามสกุล</span>
                <span class="value">{{ userName }}</span>
              </div>
              <div class="info-row">
                <span class="label">เลขบัตรประชาชน</span>
                <span class="value">{{ currentUser?.cid || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">องค์กร</span>
                <span class="value">{{ organization }}</span>
              </div>
              <div class="info-row">
                <span class="label">เบอร์โทรศัพท์</span>
                <span class="value">{{ phoneNumber }}</span>
              </div>
              <div class="card-action">
                <button class="btn-edit" (click)="navigateToEditUserInfo()">
                  <i class="bi bi-pencil-square"></i>
                  แก้ไขข้อมูล
                </button>
                <button class="btn-change-password" (click)="navigateToChangePassword()">
                  <i class="bi bi-key"></i>
                  เปลี่ยนรหัสผ่าน
                </button>
              </div>
            </div>
          </div>

          <!-- Membership Card (ข้อมูลบัตรสมาชิก) -->
          <div class="membership-id-card">
            <div class="card-header-badge">
              <i class="bi bi-credit-card-2-front"></i>
              <h3>ข้อมูลบัตรสมาชิก</h3>
              <span class="status-badge" [ngClass]="getMembershipStatusClass()">
                @if (isLoadingVatCard) {
                <span class="spinner-border spinner-border-sm"></span>
                }
                @if (!isLoadingVatCard) {
                <span>{{ getMembershipStatusText() }}</span>
                }
              </span>
            </div>
            <div class="card-body-info">
              <!-- <div class="card-field">
                <label>ประเภทสมาชิก</label>
                <div class="field-value" *ngIf="!isLoadingVatCard">{{ vatType || '-' }}</div>
                <div class="field-value loading" *ngIf="isLoadingVatCard">
                  <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                </div>
              </div> -->
              <div class="card-field">
                <label>เลขที่บัตร</label>
                @if (!isLoadingVatCard) {
                <div class="field-value">{{ vatMemberCardNumber || '-' }}</div>
                }
                @if (isLoadingVatCard) {
                <div class="field-value loading">
                  <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                </div>
                }
              </div>
              <div class="card-field">
                <label>บัตรหมดอายุ</label>
                @if (!isLoadingVatCard) {
                <div class="field-value expiry-date">
                  {{ vatMemberCardExpiryText }}
                </div>
                }
                @if (isLoadingVatCard) {
                <div class="field-value loading">
                  <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                </div>
                }
                @if (!isLoadingVatCard && isVatExpired) {
                <div class="expiry-warning">หมดอายุแล้ว</div>
                }
                @if (!isLoadingVatCard && isVatExpiringSoon && !isVatExpired) {
                <div class="expiry-warning warning">
                  หมดอายุใน {{ vatExpiringDays }} วัน
                </div>
                }
              </div>
            </div>
            <div class="card-footer-actions">
              <!-- Show buttons only for approved users (userStatusId = 1 or null) -->
              @if (shouldShowActiveCourses) {
              <button class="btn-renew yellow" (click)="openRenewMemberForm()">
                ต่ออายุบัตรสมาชิก
              </button>
              <button class="btn-view-card teal" (click)="openRegistrationForm()">
                ใบคำขอทำบัตรสมาชิก
              </button>
              }
              <!-- Show message for pending/rejected users (userStatusId = 2 or 3) -->
              @if (!shouldShowActiveCourses) {
              <div class="approval-required-message">
                <i class="bi bi-info-circle me-2"></i>
                ต้องเป็นสมาชิกที่ได้การ Approve ข้อมูลแล้วเท่านั้น
              </div>
              }
            </div>

            <!-- Payment Info Banner -->
            <div class="payment-info-banner">
              <div class="payment-info-icon">
                <i class="bi bi-bank2"></i>
              </div>
              <div class="payment-info-content">
                <div class="payment-info-title">
                  <i class="bi bi-credit-card me-1"></i>ช่องทางการชำระเงิน
                </div>
                <div class="bank-name">ธนาคารกรุงเทพ จำกัด (มหาชน)</div>
                <div class="bank-detail-row">
                  <span class="detail-label">ชื่อบัญชี</span>
                  <span class="detail-value">สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย สาขาบางยี่ขัน</span>
                </div>
                <div class="bank-detail-row">
                  <span class="detail-label">ประเภทบัญชี</span>
                  <span class="detail-value">สะสมทรัพย์</span>
                </div>
                <div class="bank-detail-row">
                  <span class="detail-label">เลขที่บัญชี</span>
                  <span class="detail-value account-number">137-0-98709-9</span>
                </div>
              </div>
            </div>

            <!-- Request List Section -->
            <div class="card-request-list">
              <div class="request-list-header">
                <i class="bi bi-list-ul"></i>
                <span>รายการคำขอ ใบคำขอทำบัตรสมาชิก</span>
              </div>

              <!-- Loading State -->
              @if (isLoadingMemberRequests) {
              <div class="request-loading">
                <span class="spinner-border spinner-border-sm me-2"></span>
                <span>กำลังโหลดรายการคำขอ...</span>
              </div>
              }

              <!-- Empty State -->
              @if (!isLoadingMemberRequests && memberRequests.length === 0) {
              <div class="request-empty">
                <i class="bi bi-inbox"></i>
                <span>ไม่มีรายการคำขอ</span>
              </div>
              }

              <!-- Request Items -->
              @if (!isLoadingMemberRequests && memberRequests.length > 0) {
              <div class="request-items">
                @for (request of memberRequests; track request.id) {
                <div class="request-item">
                  <div class="request-item-header">
                    <div class="request-info">
                      <span class="request-type">{{ request.membershipType }}</span>
                      <span class="request-date">{{ formatRequestDate(request.createdAt) }}</span>
                    </div>
                    <div class="request-badges">
                      <span class="badge" [ngClass]="getRequestStatusClass(request.status)">
                        {{ request.status }}
                      </span>
                      <span class="badge" [ngClass]="getPaymentStatusClass(request.paymentStatus)">
                        {{ request.paymentStatus }}
                      </span>
                    </div>
                  </div>
                  <div class="request-item-body">
                    <div class="request-detail">
                      <span class="label">ระดับการศึกษา:</span>
                      <span class="value">{{ request.educationLevel }}</span>
                    </div>
                    <div class="request-detail">
                      <span class="label">ค่าธรรมเนียม:</span>
                      <span class="value">{{ formatPrice(request.feeAmount) }} บาท</span>
                    </div>

                    <!-- Payment Slip Preview Button -->
                    @if (request.paymentSlip) {
                    <div class="payment-slip-preview-btn">
                      <button class="btn-preview-slip" (click)="openPaymentSlipPreview(request.paymentSlip)">
                        <i class="bi bi-image"></i>
                        <span>ดูหลักฐานการชำระเงิน</span>
                      </button>
                      @if (request.paymentStatus === 'ชำระเงินเสร็จสิ้น') {
                      <button class="btn-download-receipt" (click)="downloadReceipt(request.id, 'member-card')">
                        <i class="bi bi-download"></i>
                        <span>ดาวน์โหลดใบเสร็จ</span>
                      </button>
                      }
                    </div>
                    }

                    @if (request.remarks) {
                    <div class="request-detail">
                      <span class="label">หมายเหตุ:</span>
                      <span class="value">{{ request.remarks }}</span>
                    </div>
                    }

                    <!-- Payment Slip Upload Section -->
                    @if (canUploadPaymentSlip(request.paymentStatus)) {
                    <div class="payment-slip-upload">

                      <!-- Receipt Type Selection (only for รอชำระเงิน) -->
                      @if (request.paymentStatus === 'รอชำระเงิน') {
                      <div class="receipt-type-section">
                        <div class="receipt-type-header">
                          <i class="bi bi-file-earmark-text"></i>
                          <span>{{ isMemberReceiptTypeReadOnly(request.id) ? 'ประเภทใบเสร็จที่เลือก:' : 'เลือกประเภทใบเสร็จ:' }}</span>
                        </div>
                        @if (isMemberReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-readonly">
                          <i class="bi"
                            [class.bi-person-circle]="getMemberReceiptType(request.id) === 'individual'"
                            [class.bi-building]="getMemberReceiptType(request.id) === 'company'"></i>
                          <span>{{ getMemberReceiptTypeLabel(getMemberReceiptType(request.id)) }}</span>
                          <span class="badge bg-success ms-2">
                            <i class="bi bi-check-circle me-1"></i>บันทึกแล้ว
                          </span>
                        </div>
                        }
                        @if (!isMemberReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-options">
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'memberReceiptType-' + request.id" value="individual"
                              [checked]="getMemberReceiptType(request.id) === 'individual'"
                              (change)="onMemberReceiptTypeChange(request.id, 'individual')">
                            <i class="bi bi-person-circle"></i>
                            <span>ออกใบเสร็จรูปแบบส่วนบุคคล</span>
                          </label>
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'memberReceiptType-' + request.id" value="company"
                              [checked]="getMemberReceiptType(request.id) === 'company'"
                              (change)="onMemberReceiptTypeChange(request.id, 'company')">
                            <i class="bi bi-building"></i>
                            <span>ออกใบเสร็จรูปแบบบริษัท</span>
                          </label>
                        </div>
                        }
                      </div>

                      <!-- Transfer DateTime Input -->
                      <div class="transfer-datetime-section">
                        <div class="datetime-header">
                          <i class="bi bi-clock-history"></i>
                          <span>แจ้งวันที่และเวลาการโอนเงิน <span class="text-danger">*</span></span>
                        </div>
                        <input type="datetime-local" class="form-control datetime-input"
                          [id]="'memberTransferDateTime-' + request.id"
                          (change)="onMemberTransferDateTimeChange(request.id, $event)"
                          [max]="currentYear + '-12-31T23:59'">
                        @if (getMemberTransferDateTime(request.id)) {
                        <small class="datetime-selected">
                          <i class="bi bi-check-circle-fill me-1"></i>{{ getMemberTransferDateTime(request.id) }}
                        </small>
                        }
                        @if (!getMemberTransferDateTime(request.id)) {
                        <small class="datetime-hint">
                          <i class="bi bi-info-circle me-1"></i>กรุณาระบุวันที่และเวลาที่ทำการโอนเงินจริง
                        </small>
                        }
                      </div>
                      }

                      <div class="upload-header">
                        <i class="bi bi-cloud-upload"></i>
                        <span>แนบสลิปการชำระเงิน</span>
                      </div>
                      <div class="upload-body">
                        <label [for]="'payment-slip-' + request.id" class="upload-label">
                          @if (!isUploadingSlip(request.id)) {
                          <div class="upload-icon">
                            <i class="bi bi-image"></i>
                          </div>
                          <div class="upload-text">
                            <span class="upload-title">คลิกเพื่อเลือกไฟล์</span>
                            <span class="upload-subtitle">รองรับไฟล์ JPG, PNG (สูงสุด 5MB)</span>
                          </div>
                          @if (getSelectedMemberFileName(request.id)) {
                          <span class="selected-file-name">{{ getSelectedMemberFileName(request.id) }}</span>
                          }
                          }
                          @if (isUploadingSlip(request.id)) {
                          <div class="upload-loading">
                            <span class="spinner-border spinner-border-sm"></span>
                            <span>กำลังอัปโหลด...</span>
                          </div>
                          }
                        </label>
                        <input type="file" [id]="'payment-slip-' + request.id" accept="image/jpeg,image/jpg,image/png"
                          (change)="onMemberPaymentSlipSelected($event, request.id)"
                          [disabled]="isUploadingSlip(request.id)" class="upload-input" />
                      </div>
                      <button class="btn-submit-slip"
                        [disabled]="!getSelectedMemberFileName(request.id) || isUploadingSlip(request.id)"
                        (click)="submitMemberPaymentSlip(request.id)">
                        <i class="bi bi-send-fill me-2"></i>
                        {{ isUploadingSlip(request.id) ? 'กำลังส่ง...' : 'ส่งสลิปการชำระเงิน' }}
                      </button>
                      <div class="upload-info">
                        <i class="bi bi-info-circle"></i>
                        <span>กรุณาแนบสลิปการโอนเงินเพื่อยืนยันการชำระค่าธรรมเนียม</span>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>

            <!-- Member Renewal Request List Section -->
            <div class="card-request-list">
              <div class="request-list-header">
                <i class="bi bi-arrow-repeat"></i>
                <span>รายการคำขอ ใบคำขอต่ออายุสมาชิก</span>
              </div>

              <!-- Loading State -->
              @if (isLoadingMemberRenewalRequests) {
              <div class="request-loading">
                <span class="spinner-border spinner-border-sm me-2"></span>
                <span>กำลังโหลดรายการคำขอต่ออายุ...</span>
              </div>
              }

              <!-- Empty State -->
              @if (!isLoadingMemberRenewalRequests && memberRenewalRequests.length === 0) {
              <div class="request-empty">
                <i class="bi bi-inbox"></i>
                <span>ไม่มีรายการคำขอต่ออายุ</span>
              </div>
              }

              <!-- Request Items -->
              @if (!isLoadingMemberRenewalRequests && memberRenewalRequests.length > 0) {
              <div class="request-items">
                @for (request of memberRenewalRequests; track request.id) {
                <div class="request-item">
                  <div class="request-item-header">
                    <div class="request-info">
                      <span class="request-type">ต่ออายุสมาชิก</span>
                      <span class="request-date">{{ formatRequestDate(request.createdAt) }}</span>
                    </div>
                    <div class="request-badges">
                      <span class="badge" [ngClass]="getRequestStatusClass(request.status)">
                        {{ request.status }}
                      </span>
                      <span class="badge" [ngClass]="getPaymentStatusClass(request.paymentStatus)">
                        {{ request.paymentStatus }}
                      </span>
                    </div>
                  </div>
                  <div class="request-item-body">
                    <div class="request-detail">
                      <span class="label">{{ getRenewPeriodLabel(request) }}</span>
                      <span class="value">{{ getRenewPeriodText(request) }}</span>
                    </div>
                    <!-- ต่ออายุตลอดชีพไม่มีวันหมดอายุ -->
                    <div class="request-detail" *ngIf="isLifetimeRenewalRequest(request)">
                      <span class="label">วันหมดอายุ:</span>
                      <span class="value">ไม่มีวันหมดอายุ (ตลอดชีพ)</span>
                    </div>
                    <div class="request-detail">
                      <span class="label">ค่าธรรมเนียม:</span>
                      <span class="value">{{ formatPrice(request.feeAmount) }} บาท</span>
                    </div>

                    <!-- Payment Slip Preview Button -->
                    @if (request.paymentSlip) {
                    <div class="payment-slip-preview-btn">
                      <button class="btn-preview-slip" (click)="openPaymentSlipPreview(request.paymentSlip)">
                        <i class="bi bi-image"></i>
                        <span>ดูหลักฐานการชำระเงิน</span>
                      </button>
                      @if (request.paymentStatus === 'ชำระเงินเสร็จสิ้น') {
                      <button class="btn-download-receipt" (click)="downloadReceipt(request.id, 'renew-member')">
                        <i class="bi bi-download"></i>
                        <span>ดาวน์โหลดใบเสร็จ</span>
                      </button>
                      }
                    </div>
                    }

                    @if (request.remarks) {
                    <div class="request-detail">
                      <span class="label">หมายเหตุ:</span>
                      <span class="value">{{ request.remarks }}</span>
                    </div>
                    }

                    <!-- Payment Slip Upload Section -->
                    @if (canUploadPaymentSlip(request.paymentStatus)) {
                    <div class="payment-slip-upload">

                      <!-- Receipt Type Selection (only for รอชำระเงิน) -->
                      @if (request.paymentStatus === 'รอชำระเงิน') {
                      <div class="receipt-type-section">
                        <div class="receipt-type-header">
                          <i class="bi bi-file-earmark-text"></i>
                          <span>{{ isRenewalReceiptTypeReadOnly(request.id) ? 'ประเภทใบเสร็จที่เลือก:' : 'เลือกประเภทใบเสร็จ:' }}</span>
                        </div>
                        @if (isRenewalReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-readonly">
                          <i class="bi"
                            [class.bi-person-circle]="getRenewalReceiptType(request.id) === 'individual'"
                            [class.bi-building]="getRenewalReceiptType(request.id) === 'company'"></i>
                          <span>{{ getRenewalReceiptTypeLabel(getRenewalReceiptType(request.id)) }}</span>
                          <span class="badge bg-success ms-2">
                            <i class="bi bi-check-circle me-1"></i>บันทึกแล้ว
                          </span>
                        </div>
                        }
                        @if (!isRenewalReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-options">
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'renewalReceiptType-' + request.id" value="individual"
                              [checked]="getRenewalReceiptType(request.id) === 'individual'"
                              (change)="onRenewalReceiptTypeChange(request.id, 'individual')">
                            <i class="bi bi-person-circle"></i>
                            <span>ออกใบเสร็จรูปแบบส่วนบุคคล</span>
                          </label>
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'renewalReceiptType-' + request.id" value="company"
                              [checked]="getRenewalReceiptType(request.id) === 'company'"
                              (change)="onRenewalReceiptTypeChange(request.id, 'company')">
                            <i class="bi bi-building"></i>
                            <span>ออกใบเสร็จรูปแบบบริษัท</span>
                          </label>
                        </div>
                        }
                      </div>

                      <!-- Transfer DateTime Input -->
                      <div class="transfer-datetime-section">
                        <div class="datetime-header">
                          <i class="bi bi-clock-history"></i>
                          <span>แจ้งวันที่และเวลาการโอนเงิน <span class="text-danger">*</span></span>
                        </div>
                        <input type="datetime-local" class="form-control datetime-input"
                          [id]="'renewalTransferDateTime-' + request.id"
                          (change)="onRenewalTransferDateTimeChange(request.id, $event)"
                          [max]="currentYear + '-12-31T23:59'">
                        @if (getRenewalTransferDateTime(request.id)) {
                        <small class="datetime-selected">
                          <i class="bi bi-check-circle-fill me-1"></i>{{ getRenewalTransferDateTime(request.id) }}
                        </small>
                        }
                        @if (!getRenewalTransferDateTime(request.id)) {
                        <small class="datetime-hint">
                          <i class="bi bi-info-circle me-1"></i>กรุณาระบุวันที่และเวลาที่ทำการโอนเงินจริง
                        </small>
                        }
                      </div>
                      }

                      <div class="upload-header">
                        <i class="bi bi-cloud-upload"></i>
                        <span>แนบสลิปการชำระเงิน</span>
                      </div>
                      <div class="upload-body">
                        <label [for]="'renewal-payment-slip-' + request.id" class="upload-label">
                          @if (!isUploadingSlip(request.id)) {
                          <div class="upload-icon">
                            <i class="bi bi-image"></i>
                          </div>
                          <div class="upload-text">
                            <span class="upload-title">คลิกเพื่อเลือกไฟล์</span>
                            <span class="upload-subtitle">รองรับไฟล์ JPG, PNG (สูงสุด 5MB)</span>
                          </div>
                          @if (getSelectedRenewalFileName(request.id)) {
                          <span class="selected-file-name">{{ getSelectedRenewalFileName(request.id) }}</span>
                          }
                          }
                          @if (isUploadingSlip(request.id)) {
                          <div class="upload-loading">
                            <span class="spinner-border spinner-border-sm"></span>
                            <span>กำลังอัปโหลด...</span>
                          </div>
                          }
                        </label>
                        <input type="file" [id]="'renewal-payment-slip-' + request.id"
                          accept="image/jpeg,image/jpg,image/png"
                          (change)="onRenewalPaymentSlipFileSelected($event, request.id)"
                          [disabled]="isUploadingSlip(request.id)" class="upload-input" />
                      </div>
                      <button class="btn-submit-slip"
                        [disabled]="!getSelectedRenewalFileName(request.id) || isUploadingSlip(request.id)"
                        (click)="submitRenewalPaymentSlip(request.id)">
                        <i class="bi bi-send-fill me-2"></i>
                        {{ isUploadingSlip(request.id) ? 'กำลังส่ง...' : 'ส่งสลิปการชำระเงิน' }}
                      </button>
                      <div class="upload-info">
                        <i class="bi bi-info-circle"></i>
                        <span>กรุณาแนบสลิปการโอนเงินเพื่อยืนยันการชำระค่าธรรมเนียม</span>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
          </div>

          <!-- Valuer Card (ข้อมูลบัตรผู้ประเมินหลัก) -->
          <div class="membership-id-card valuer-card">
            <div class="card-header-badge">
              <i class="bi bi-award"></i>
              <h3>ข้อมูลบัตรผู้ประเมินหลัก</h3>
              <span class="status-badge" [ngClass]="{
                'active': valuerCardNumber && !isValuerExpired,
                'expired': isValuerExpired,
                'inactive': !valuerCardNumber
              }">
                @if (isLoadingValuerCard) {
                <span class="spinner-border spinner-border-sm"></span>
                }
                @if (!isLoadingValuerCard && valuerCardNumber && !isValuerExpired) {
                <span>{{ valuerType || '-'
                  }}</span>
                }
                @if (!isLoadingValuerCard && isValuerExpired) {
                <span>หมดอายุ</span>
                }
                @if (!isLoadingValuerCard && !valuerCardNumber) {
                <span>ยังไม่มีบัตร</span>
                }
              </span>
            </div>
            <div class="card-body-info">
              <!-- <div class="card-field">
                <label>ผู้ประเมินหลักประเภท</label>
                <div class="field-value" *ngIf="!isLoadingValuerCard">{{ valuerType || '-' }}</div>
                <div class="field-value loading" *ngIf="isLoadingValuerCard">
                  <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                </div>
              </div> -->
              <div class="card-field">
                <label>เลขที่บัตร</label>
                @if (!isLoadingValuerCard) {
                <div class="field-value">{{ valuerCardNumber || '-' }}</div>
                }
                @if (isLoadingValuerCard) {
                <div class="field-value loading">
                  <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                </div>
                }
              </div>
              <div class="card-field">
                <label>บัตรหมดอายุ</label>
                @if (!isLoadingValuerCard) {
                <div class="field-value expiry-date">
                  {{ valuerCardExpiry ? formatDate(valuerCardExpiry) : '-' }}
                </div>
                }
                @if (isLoadingValuerCard) {
                <div class="field-value loading">
                  <span class="spinner-border spinner-border-sm me-1"></span>กำลังโหลด...
                </div>
                }
                @if (!isLoadingValuerCard && isValuerExpired) {
                <div class="expiry-warning">หมดอายุแล้ว</div>
                }
                @if (!isLoadingValuerCard && isValuerExpiringSoon && !isValuerExpired) {
                <div class="expiry-warning warning">
                  หมดอายุใน {{ valuerExpiringDays }} วัน
                </div>
                }
              </div>
            </div>
            <div class="card-footer-actions">
              <!-- Show buttons only for approved users (userStatusId = 1 or null) -->
              @if (shouldShowActiveCourses) {
              <button class="btn-renew yellow" (click)="openAppraiserRenewalForm()">
                คำขอต่ออายุบัตร
              </button>
              <button class="btn-register red" (click)="openAppraiserRegistrationForm()">
                ใบคำขอขึ้นทะเบียน
              </button>
              }
              <!-- Show message for pending/rejected users (userStatusId = 2 or 3) -->
              @if (!shouldShowActiveCourses) {
              <div class="approval-required-message">
                <i class="bi bi-info-circle me-2"></i>
                ต้องเป็นสมาชิกที่ได้การ Approve ข้อมูลแล้วเท่านั้น
              </div>
              }
            </div>

            <!-- Payment Info Banner -->
            <div class="payment-info-banner valuer-banner">
              <div class="payment-info-icon">
                <i class="bi bi-bank2"></i>
              </div>
              <div class="payment-info-content">
                <div class="payment-info-title">
                  <i class="bi bi-credit-card me-1"></i>ช่องทางการชำระเงิน
                </div>
                <div class="bank-name">ธนาคารกรุงเทพ จำกัด (มหาชน)</div>
                <div class="bank-detail-row">
                  <span class="detail-label">ชื่อบัญชี</span>
                  <span class="detail-value">สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย สาขาบางยี่ขัน</span>
                </div>
                <div class="bank-detail-row">
                  <span class="detail-label">ประเภทบัญชี</span>
                  <span class="detail-value">สะสมทรัพย์</span>
                </div>
                <div class="bank-detail-row">
                  <span class="detail-label">เลขที่บัญชี</span>
                  <span class="detail-value account-number">137-0-98709-9</span>
                </div>
              </div>
            </div>

            <!-- Appraiser Registration Request List Section -->
            <div class="card-request-list">
              <div class="request-list-header">
                <i class="bi bi-list-ul"></i>
                <span>รายการคำขอ ใบคำขอขึ้นทะเบียนผู้ประเมินหลัก</span>
              </div>

              <!-- Loading State -->
              @if (isLoadingAppraiserRequests) {
              <div class="request-loading">
                <span class="spinner-border spinner-border-sm me-2"></span>
                <span>กำลังโหลดรายการคำขอ...</span>
              </div>
              }

              <!-- Empty State -->
              @if (!isLoadingAppraiserRequests && appraiserRequests.length === 0) {
              <div class="request-empty">
                <i class="bi bi-inbox"></i>
                <span>ไม่มีรายการคำขอ</span>
              </div>
              }

              <!-- Request Items -->
              @if (!isLoadingAppraiserRequests && appraiserRequests.length > 0) {
              <div class="request-items">
                @for (request of appraiserRequests; track request.id) {
                <div class="request-item">
                  <div class="request-item-header">
                    <div class="request-info">
                      <span class="request-type">{{ request.appraiserLevel }}</span>
                      <span class="request-date">{{ formatRequestDate(request.createdAt) }}</span>
                    </div>
                    <div class="request-badges">
                      <span class="badge" [ngClass]="getRequestStatusClass(request.status)">
                        {{ request.status }}
                      </span>
                      <span class="badge" [ngClass]="getPaymentStatusClass(request.paymentStatus)">
                        {{ request.paymentStatus }}
                      </span>
                    </div>
                  </div>
                  <div class="request-item-body">
                    <div class="request-detail">
                      <span class="label">ค่าธรรมเนียม:</span>
                      <span class="value">{{ formatPrice(request.feeAmount) }} บาท</span>
                    </div>

                    <!-- Payment Slip Preview Button -->
                    @if (request.paymentSlip) {
                    <div class="payment-slip-preview-btn">
                      <button class="btn-preview-slip" (click)="openPaymentSlipPreview(request.paymentSlip)">
                        <i class="bi bi-image"></i>
                        <span>ดูหลักฐานการชำระเงิน</span>
                      </button>
                      @if (request.paymentStatus === 'ชำระเงินเสร็จสิ้น') {
                      <button class="btn-download-receipt"
                        (click)="downloadReceipt(request.id, 'register-appraiser')">
                        <i class="bi bi-download"></i>
                        <span>ดาวน์โหลดใบเสร็จ</span>
                      </button>
                      }
                    </div>
                    }

                    @if (request.remarks) {
                    <div class="request-detail">
                      <span class="label">หมายเหตุ:</span>
                      <span class="value">{{ request.remarks }}</span>
                    </div>
                    }

                    <!-- Payment Slip Upload Section -->
                    @if (canUploadPaymentSlip(request.paymentStatus)) {
                    <div class="payment-slip-upload">

                      <!-- Receipt Type Selection (only for รอชำระเงิน) -->
                      @if (request.paymentStatus === 'รอชำระเงิน') {
                      <div class="receipt-type-section">
                        <div class="receipt-type-header">
                          <i class="bi bi-file-earmark-text"></i>
                          <span>{{ isAppraiserReceiptTypeReadOnly(request.id) ? 'ประเภทใบเสร็จที่เลือก:' : 'เลือกประเภทใบเสร็จ:' }}</span>
                        </div>
                        @if (isAppraiserReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-readonly">
                          <i class="bi"
                            [class.bi-person-circle]="getAppraiserReceiptType(request.id) === 'individual'"
                            [class.bi-building]="getAppraiserReceiptType(request.id) === 'company'"></i>
                          <span>{{ getAppraiserReceiptTypeLabel(getAppraiserReceiptType(request.id)) }}</span>
                          <span class="badge bg-success ms-2">
                            <i class="bi bi-check-circle me-1"></i>บันทึกแล้ว
                          </span>
                        </div>
                        }
                        @if (!isAppraiserReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-options">
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'appraiserReceiptType-' + request.id" value="individual"
                              [checked]="getAppraiserReceiptType(request.id) === 'individual'"
                              (change)="onAppraiserReceiptTypeChange(request.id, 'individual')">
                            <i class="bi bi-person-circle"></i>
                            <span>ออกใบเสร็จรูปแบบส่วนบุคคล</span>
                          </label>
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'appraiserReceiptType-' + request.id" value="company"
                              [checked]="getAppraiserReceiptType(request.id) === 'company'"
                              (change)="onAppraiserReceiptTypeChange(request.id, 'company')">
                            <i class="bi bi-building"></i>
                            <span>ออกใบเสร็จรูปแบบบริษัท</span>
                          </label>
                        </div>
                        }
                      </div>

                      <!-- Transfer DateTime Input -->
                      <div class="transfer-datetime-section">
                        <div class="datetime-header">
                          <i class="bi bi-clock-history"></i>
                          <span>แจ้งวันที่และเวลาการโอนเงิน <span class="text-danger">*</span></span>
                        </div>
                        <input type="datetime-local" class="form-control datetime-input"
                          [id]="'appraiserTransferDateTime-' + request.id"
                          (change)="onAppraiserTransferDateTimeChange(request.id, $event)"
                          [max]="currentYear + '-12-31T23:59'">
                        @if (getAppraiserTransferDateTime(request.id)) {
                        <small class="datetime-selected">
                          <i class="bi bi-check-circle-fill me-1"></i>{{ getAppraiserTransferDateTime(request.id) }}
                        </small>
                        }
                        @if (!getAppraiserTransferDateTime(request.id)) {
                        <small class="datetime-hint">
                          <i class="bi bi-info-circle me-1"></i>กรุณาระบุวันที่และเวลาที่ทำการโอนเงินจริง
                        </small>
                        }
                      </div>
                      }

                      <div class="upload-header">
                        <i class="bi bi-cloud-upload"></i>
                        <span>แนบสลิปการชำระเงิน</span>
                      </div>
                      <div class="upload-body">
                        <label [for]="'appraiser-payment-slip-' + request.id" class="upload-label">
                          @if (!isUploadingSlip(request.id)) {
                          <div class="upload-icon">
                            <i class="bi bi-image"></i>
                          </div>
                          <div class="upload-text">
                            <span class="upload-title">คลิกเพื่อเลือกไฟล์</span>
                            <span class="upload-subtitle">รองรับไฟล์ JPG, PNG (สูงสุด 5MB)</span>
                          </div>
                          @if (getSelectedAppraiserFileName(request.id)) {
                          <span class="selected-file-name">{{ getSelectedAppraiserFileName(request.id) }}</span>
                          }
                          }
                          @if (isUploadingSlip(request.id)) {
                          <div class="upload-loading">
                            <span class="spinner-border spinner-border-sm"></span>
                            <span>กำลังอัปโหลด...</span>
                          </div>
                          }
                        </label>
                        <input type="file" [id]="'appraiser-payment-slip-' + request.id"
                          accept="image/jpeg,image/jpg,image/png"
                          (change)="onAppraiserPaymentSlipSelected($event, request.id)"
                          [disabled]="isUploadingSlip(request.id)" class="upload-input" />
                      </div>
                      <button class="btn-submit-slip"
                        [disabled]="!getSelectedAppraiserFileName(request.id) || isUploadingSlip(request.id)"
                        (click)="submitAppraiserPaymentSlip(request.id)">
                        <i class="bi bi-send-fill me-2"></i>
                        {{ isUploadingSlip(request.id) ? 'กำลังส่ง...' : 'ส่งสลิปการชำระเงิน' }}
                      </button>
                      <div class="upload-info">
                        <i class="bi bi-info-circle"></i>
                        <span>กรุณาแนบสลิปการโอนเงินเพื่อยืนยันการชำระค่าธรรมเนียม</span>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>

            <!-- Appraiser Renewal Request List Section -->
            <div class="card-request-list">
              <div class="request-list-header">
                <i class="bi bi-arrow-repeat"></i>
                <span>รายการคำขอ ใบคำขอต่ออายุผู้ประเมินหลัก</span>
              </div>

              <!-- Loading State -->
              @if (isLoadingAppraiserRenewalRequests) {
              <div class="request-loading">
                <span class="spinner-border spinner-border-sm me-2"></span>
                <span>กำลังโหลดรายการคำขอต่ออายุ...</span>
              </div>
              }

              <!-- Empty State -->
              @if (!isLoadingAppraiserRenewalRequests && appraiserRenewalRequests.length === 0) {
              <div class="request-empty">
                <i class="bi bi-inbox"></i>
                <span>ไม่มีรายการคำขอต่ออายุ</span>
              </div>
              }

              <!-- Request Items -->
              @if (!isLoadingAppraiserRenewalRequests && appraiserRenewalRequests.length > 0) {
              <div class="request-items">
                @for (request of appraiserRenewalRequests; track request.id) {
                <div class="request-item">
                  <div class="request-item-header">
                    <div class="request-info">
                      <span class="request-type">ต่ออายุผู้ประเมิน</span>
                      <span class="request-date">{{ formatRequestDate(request.createdAt) }}</span>
                    </div>
                    <div class="request-badges">
                      <span class="badge" [ngClass]="getRequestStatusClass(request.status)">
                        {{ request.status }}
                      </span>
                      <span class="badge" [ngClass]="getPaymentStatusClass(request.paymentStatus)">
                        {{ request.paymentStatus }}
                      </span>
                    </div>
                  </div>
                  <div class="request-item-body">
                    <div class="request-detail">
                      <span class="label">ค่าธรรมเนียม:</span>
                      <span class="value">{{ formatPrice(request.feeAmount) }} บาท</span>
                    </div>

                    <!-- Payment Slip Preview Button -->
                    @if (request.paymentSlip) {
                    <div class="payment-slip-preview-btn">
                      <button class="btn-preview-slip" (click)="openPaymentSlipPreview(request.paymentSlip)">
                        <i class="bi bi-image"></i>
                        <span>ดูหลักฐานการชำระเงิน</span>
                      </button>
                      @if (request.paymentStatus === 'ชำระเงินเสร็จสิ้น') {
                      <button class="btn-download-receipt" (click)="downloadReceipt(request.id, 'appraiser-renewal')">
                        <i class="bi bi-download"></i>
                        <span>ดาวน์โหลดใบเสร็จ</span>
                      </button>
                      }
                    </div>
                    }

                    @if (request.remarks) {
                    <div class="request-detail">
                      <span class="label">หมายเหตุ:</span>
                      <span class="value">{{ request.remarks }}</span>
                    </div>
                    }

                    <!-- Payment Slip Upload Section -->
                    @if (canUploadPaymentSlip(request.paymentStatus)) {
                    <div class="payment-slip-upload">

                      <!-- Receipt Type Selection (only for รอชำระเงิน) -->
                      @if (request.paymentStatus === 'รอชำระเงิน') {
                      <div class="receipt-type-section">
                        <div class="receipt-type-header">
                          <i class="bi bi-file-earmark-text"></i>
                          <span>{{ isAppraiserRenewalReceiptTypeReadOnly(request.id) ? 'ประเภทใบเสร็จที่เลือก:' : 'เลือกประเภทใบเสร็จ:' }}</span>
                        </div>
                        @if (isAppraiserRenewalReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-readonly">
                          <i class="bi"
                            [class.bi-person-circle]="getAppraiserRenewalReceiptType(request.id) === 'individual'"
                            [class.bi-building]="getAppraiserRenewalReceiptType(request.id) === 'company'"></i>
                          <span>{{ getAppraiserRenewalReceiptTypeLabel(getAppraiserRenewalReceiptType(request.id)) }}</span>
                          <span class="badge bg-success ms-2">
                            <i class="bi bi-check-circle me-1"></i>บันทึกแล้ว
                          </span>
                        </div>
                        }
                        @if (!isAppraiserRenewalReceiptTypeReadOnly(request.id)) {
                        <div class="receipt-type-options">
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'appraiserRenewalReceiptType-' + request.id" value="individual"
                              [checked]="getAppraiserRenewalReceiptType(request.id) === 'individual'"
                              (change)="onAppraiserRenewalReceiptTypeChange(request.id, 'individual')">
                            <i class="bi bi-person-circle"></i>
                            <span>ออกใบเสร็จรูปแบบส่วนบุคคล</span>
                          </label>
                          <label class="receipt-type-option">
                            <input type="radio" [name]="'appraiserRenewalReceiptType-' + request.id" value="company"
                              [checked]="getAppraiserRenewalReceiptType(request.id) === 'company'"
                              (change)="onAppraiserRenewalReceiptTypeChange(request.id, 'company')">
                            <i class="bi bi-building"></i>
                            <span>ออกใบเสร็จรูปแบบบริษัท</span>
                          </label>
                        </div>
                        }
                      </div>

                      <!-- Transfer DateTime Input -->
                      <div class="transfer-datetime-section">
                        <div class="datetime-header">
                          <i class="bi bi-clock-history"></i>
                          <span>แจ้งวันที่และเวลาการโอนเงิน <span class="text-danger">*</span></span>
                        </div>
                        <input type="datetime-local" class="form-control datetime-input"
                          [id]="'appraiserRenewalTransferDateTime-' + request.id"
                          (change)="onAppraiserRenewalTransferDateTimeChange(request.id, $event)"
                          [max]="currentYear + '-12-31T23:59'">
                        @if (getAppraiserRenewalTransferDateTime(request.id)) {
                        <small class="datetime-selected">
                          <i class="bi bi-check-circle-fill me-1"></i>{{ getAppraiserRenewalTransferDateTime(request.id) }}
                        </small>
                        }
                        @if (!getAppraiserRenewalTransferDateTime(request.id)) {
                        <small class="datetime-hint">
                          <i class="bi bi-info-circle me-1"></i>กรุณาระบุวันที่และเวลาที่ทำการโอนเงินจริง
                        </small>
                        }
                      </div>
                      }

                      <div class="upload-header">
                        <i class="bi bi-cloud-upload"></i>
                        <span>แนบสลิปการชำระเงิน</span>
                      </div>
                      <div class="upload-body">
                        <label [for]="'appraiser-renewal-payment-slip-' + request.id" class="upload-label">
                          @if (!isUploadingSlip(request.id)) {
                          <div class="upload-icon">
                            <i class="bi bi-image"></i>
                          </div>
                          <div class="upload-text">
                            <span class="upload-title">คลิกเพื่อเลือกไฟล์</span>
                            <span class="upload-subtitle">รองรับไฟล์ JPG, PNG (สูงสุด 5MB)</span>
                          </div>
                          @if (getSelectedAppraiserRenewalFileName(request.id)) {
                          <span class="selected-file-name">{{ getSelectedAppraiserRenewalFileName(request.id) }}</span>
                          }
                          }
                          @if (isUploadingSlip(request.id)) {
                          <div class="upload-loading">
                            <span class="spinner-border spinner-border-sm"></span>
                            <span>กำลังอัปโหลด...</span>
                          </div>
                          }
                        </label>
                        <input type="file" [id]="'appraiser-renewal-payment-slip-' + request.id"
                          accept="image/jpeg,image/jpg,image/png"
                          (change)="onAppraiserRenewalPaymentSlipSelected($event, request.id)"
                          [disabled]="isUploadingSlip(request.id)" class="upload-input" />
                      </div>
                      <button class="btn-submit-slip"
                        [disabled]="!getSelectedAppraiserRenewalFileName(request.id) || isUploadingSlip(request.id)"
                        (click)="submitAppraiserRenewalPaymentSlip(request.id)">
                        <i class="bi bi-send-fill me-2"></i>
                        {{ isUploadingSlip(request.id) ? 'กำลังส่ง...' : 'ส่งสลิปการชำระเงิน' }}
                      </button>
                      <div class="upload-info">
                        <i class="bi bi-info-circle"></i>
                        <span>กรุณาแนบสลิปการโอนเงินเพื่อยืนยันการชำระค่าธรรมเนียม</span>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
          </div>

        </section>

        <!-- Active Courses & Exams Section -->
        @if (shouldShowActiveCourses) {
        <section class="active-courses-section">
          <div class="courses-container">
            <!-- Section Header with Tabs -->
            <div class="section-header-with-tabs">
              <div class="section-header">
                <svg class="section-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
                <div class="header-text">
                  <h3>คอร์สและการสอบที่กำลังเปิดรับสมัคร</h3>
                  <p>คอร์สอบรม สัมมนา และการสอบที่เปิดให้ลงทะเบียนในขณะนี้</p>
                </div>
              </div>

              <!-- Tabs Navigation -->
              <div class="tabs-navigation">
                <button class="tab-button" [class.active]="activeTab === 'courses'" (click)="switchTab('courses')">
                  <i class="bi bi-book"></i>
                  <span>คอร์สที่กำลังเปิดรับสมัคร</span>
                </button>
                <button class="tab-button" [class.active]="activeTab === 'exams'" (click)="switchTab('exams')">
                  <i class="bi bi-clipboard-check"></i>
                  <span>การสอบที่กำลังเปิดรับสมัคร</span>
                </button>
              </div>
            </div>

            <!-- Courses Tab Content -->
            @if (activeTab === 'courses') {
            <div class="tab-content">
              <!-- Loading State -->
              @if (isLoadingActiveCourses) {
              <div class="courses-loading">
                <div class="spinner-border text-primary" role="status"></div>
                <p>กำลังโหลดคอร์สที่เปิดรับสมัคร...</p>
              </div>
              }

              <!-- Empty State -->
              @if (!isLoadingActiveCourses && activeCourses.length === 0) {
              <div class="courses-empty">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <h4>ไม่มีคอร์สที่เปิดรับสมัคร</h4>
                <p>ขณะนี้ยังไม่มีคอร์สอบรมหรือสัมมนาที่เปิดรับสมัคร</p>
              </div>
              }

              <!-- Courses Grid -->
              @if (!isLoadingActiveCourses && activeCourses.length > 0) {
              <div class="courses-grid">
                @for (course of activeCourses; track course.id) {
                <div class="course-card" (click)="handleCourseCardClick(course.id)" role="button" tabindex="0"
                  style="cursor: pointer;">

                  <!-- Course Body -->
                  <div class="course-body">
                    <h4 class="course-title">{{ course.title }}</h4>

                    <!-- Course Details -->
                    <div class="course-details">
                      <div class="detail-item">
                        <span class="detail-icon">⏱️</span>
                        <span class="detail-text">จำนวน CPD : {{ course.duration }} ชั่วโมง</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-icon">✅</span>
                        <span class="detail-text">การรับรอง โดย กลต.: {{ course.certificationBySEC ? 'รับรอง' :
                          'ไม่รับรอง' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-icon">👥</span>
                        <span class="detail-text">ที่นั่ง: {{ course.regisSeat || 0 }} คน / {{ course.seat || 0 }}
                          คน</span>
                      </div>
                      @if (course.trainingLocation) {
                      <div class="detail-item">
                        <span class="detail-icon">📍</span>
                        <span class="detail-text">สถานที่อบรม: {{ course.trainingLocation }}</span>
                      </div>
                      }
                      @if (course.startDate) {
                      <div class="detail-item">
                        <span class="detail-icon">📅</span>
                        <span class="detail-text">วันที่เริ่มอบรม: {{ formatCourseDate(course.startDate) }}</span>
                      </div>
                      }
                      @if (course.endDate) {
                      <div class="detail-item">
                        <span class="detail-icon">🏁</span>
                        <span class="detail-text">วันสิ้นสุดการอบรม: {{ formatCourseDate(course.endDate) }}</span>
                      </div>
                      }
                      @if (course.closeRegisterDate) {
                      <div class="detail-item">
                        <span class="detail-icon">🏁</span>
                        <span class="detail-text">วันปิดรับการสมัคร: {{ formatCourseDate(course.closeRegisterDate)
                          }}</span>
                      </div>
                      }
                    </div>
                  </div>

                  <!-- Course Note (หมายเหตุ from course description) -->
                  @if (course.description) {
                  <div style="margin:0 16px 12px;padding:10px 14px;background:#fffbeb;border:1px solid #fde68a;border-radius:10px;">
                    <div style="font-weight:600;color:#92400e;margin-bottom:2px;font-size:0.9rem;">
                      <i class="bi bi-sticky me-1"></i>หมายเหตุ
                    </div>
                    <div style="color:#475569;font-size:0.9rem;white-space:pre-line;line-height:1.5;">{{ course.description }}</div>
                  </div>
                  }

                  <!-- Course Footer -->
                  <div class="course-footer">
                    <div class="price-section">
                      <span class="price-label">ค่าลงทะเบียนรวม Vat</span>
                      <span class="price-amount">฿{{ formatPrice(course.price) }}</span>
                    </div>
                    @if (course.courseStatusId === 2) {
                    @if (isUserRegisteredForCourse(course.id)) {
                    <div class="registered-message">
                      <i class="bi bi-check-circle-fill"></i>
                      <span>เช็คสถานะการลงทะเบียนที่นี่</span>
                    </div>
                    } @else {
                    <button class="btn-register"
                      (click)="$event.stopPropagation(); navigateToCourseRegister(course.id)">
                      ลงทะเบียน
                    </button>
                    }
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }

            <!-- Exams Tab Content -->
            @if (activeTab === 'exams') {
            <div class="tab-content">
              <!-- Loading State -->
              @if (isLoadingActiveExams) {
              <div class="courses-loading">
                <div class="spinner-border text-primary" role="status"></div>
                <p>กำลังโหลดการสอบที่เปิดรับสมัคร...</p>
              </div>
              }

              <!-- Empty State -->
              @if (!isLoadingActiveExams && activeExams.length === 0) {
              <div class="courses-empty">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <h4>ไม่มีการสอบที่เปิดรับสมัคร</h4>
                <p>ขณะนี้ยังไม่มีการสอบที่เปิดรับสมัคร</p>
              </div>
              }

              <!-- Exams Grid -->
              @if (!isLoadingActiveExams && activeExams.length > 0) {
              <div class="courses-grid">
                @for (exam of activeExams; track exam.id) {
                <div class="course-card exam-card" (click)="handleExamCardClick(exam.id)" role="button" tabindex="0"
                  style="cursor: pointer;">
                  <!-- Exam Header with Gradient -->
                  <div class="course-header exam-header">
                    <div class="course-icon">
                      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2">
                        </path>
                        <path d="M9 12l2 2 4-4"></path>
                      </svg>
                    </div>
                    <div class="header-badges">
                      <span class="status-badge" [ngClass]="getExamStatusBadgeClass(exam.examStatusId)">
                        {{ getExamStatusName(exam) }}
                      </span>
                    </div>
                  </div>

                  <!-- Exam Body -->
                  <div class="course-body">
                    <h4 class="course-title">{{ exam.examTitle }}</h4>

                    <!-- Exam Details -->
                    <div class="course-details">
                      <div class="detail-item">
                        <span class="detail-icon">🎯</span>
                        <span class="detail-text">ระดับผู้ประเมิน: {{ exam.valuerRank }}</span>
                      </div>
                      @if (exam.examDate) {
                      <div class="detail-item">
                        <span class="detail-icon">📅</span>
                        <span class="detail-text">วันสอบ: {{ formatExamDate(exam.examDate) }}</span>
                      </div>
                      }
                      @if (exam.examTime) {
                      <div class="detail-item">
                        <span class="detail-icon">⏰</span>
                        <span class="detail-text">เวลาสอบ: {{ exam.examTime }}</span>
                      </div>
                      }
                      @if (exam.examLocation) {
                      <div class="detail-item">
                        <span class="detail-icon">📍</span>
                        <span class="detail-text">สถานที่สอบ: {{ exam.examLocation }}</span>
                      </div>
                      }
                      @if (exam.registrationDeadline) {
                      <div class="detail-item">
                        <span class="detail-icon">⏳</span>
                        <span class="detail-text">ปิดรับสมัคร: {{ formatExamDate(exam.registrationDeadline) }}</span>
                      </div>
                      }
                      @if (exam.remarks) {
                      <div class="detail-item">
                        <span class="detail-icon">📝</span>
                        <span class="detail-text">{{ exam.remarks }}</span>
                      </div>
                      }
                    </div>
                  </div>

                  <!-- Exam Footer -->
                  <div class="course-footer">
                    <div class="price-section">
                      <span class="price-label">ค่าสมัครสอบรวม Vat</span>
                      <span class="price-amount">฿{{ formatPrice(exam.examFee) }}</span>
                    </div>
                    @if (exam.examStatusId === 2) {
                    @if (isUserRegisteredForExam(exam.id)) {
                    <button class="btn-register btn-track-status"
                      (click)="$event.stopPropagation(); viewExamList()">
                      <i class="bi bi-clipboard-check-fill me-1"></i>
                      ติดตามสถานะการสอบ
                    </button>
                    } @else {
                    <button class="btn-register" (click)="$event.stopPropagation(); navigateToExamRegister(exam.id)">
                      ลงทะเบียนสอบ
                    </button>
                    }
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </section>
        }
      </div>
    </main>
  </div>
  }

  <!-- User Profile Modal -->
  @if (showProfileModal) {
  <app-user-profile-modal [userDetails]="userDetails" (close)="closeProfileModal()">
  </app-user-profile-modal>
  }
</div>